<script>
import { mapActions } from 'vuex'
export default {
  name: 'module-dropdown',
  methods: {
    ...mapActions('appModule', ['changeAppModule'])
  }
}
</script>
<template>
  <b-dropdown
    class="d-none d-lg-inline-block noti-icon p-0"
    menu-class="dropdown-menu-lg"
    bottom
    toggle-class="header-item"
    variant="black"
  >
    <template v-slot:button-content>
      <i class="bx bx-customize"></i>
    </template>

    <div class="px-lg-2">
      <div class="row no-gutters">
        <div class="col">
          <b-dropdown-item
            class="dropdown-icon-item"
            v-on:click="changeAppModule('sales')"
          >
            <i class="fas fa-dollar-sign text-dark"></i>
            <span>{{ $t('modules.sales') }}</span>
          </b-dropdown-item>
        </div>
        <div class="col">
          <b-dropdown-item
            class="dropdown-icon-item"
            v-on:click="changeAppModule('purchasing')"
          >
            <i class="fas fa-dollar-sign text-dark"></i>
            <span>{{ $t('modules.purchasing') }}</span>
          </b-dropdown-item>
        </div>
        <div class="col">
          <b-dropdown-item
            class="dropdown-icon-item"
            v-on:click="changeAppModule('purchasing')"
          >
            <i class="bx bx-package text-dark"></i>
            <span>{{ $t('modules.inventory') }}</span>
          </b-dropdown-item>
        </div>
        <div class="col">
          <b-dropdown-item
            class="dropdown-icon-item"
            v-on:click="changeAppModule('purchasing')"
          >
            <i class="bx bx-package text-dark"></i>
            <span>{{ $t('modules.inventory') }}</span>
          </b-dropdown-item>
        </div>
      </div>
    </div>
  </b-dropdown>
</template>
